import React from "react";
import { QandA } from "../HomeContents/QandA";
import styled from "styled-components";

const Unanswered = () => {
    return (
        <PageWrapper>
            <Container>
                <QandA flag />
            </Container>
        </PageWrapper>
    );
};

export default Unanswered;

const PageWrapper = styled.div`
    min-height: 100vh;
    background-color: var(--primary-base-cream);
    padding: 1.5rem 0;
`;

const Container = styled.div`
    max-width: 640px;
    width: 100%;
    margin: 0 auto;
    padding: 0 1rem;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid rgba(201, 160, 99, 0.2);
    box-shadow: 0 2px 8px rgba(10, 20, 40, 0.06);
`;
